import axios from "axios"

export const api = axios.create({
    //"http://localhost:8000/api",
    baseURL: "https://alumni.rgu.ac.in/admin/api",
    headers: { "Content-Type": "application/json" },
})
